import {Fragment} from 'react'
import {type RoleCheckerProps} from './types'
import rolesCheckerReselector from './roles-checker-reselector'
import {isUserAllowed} from '../../values/Role'
import usedTypeSelector from '../../hooks/use-typed-selector'

const RoleChecker = ({rolesAllowed, children}: React.PropsWithChildren<RoleCheckerProps>) => {
    if (!isUserAllowed(usedTypeSelector(rolesCheckerReselector), rolesAllowed)) {
        return null
    }

    return <Fragment>{children}</Fragment>
}

export default RoleChecker
